<template>
  <div class="ren-decoration-cp ren-decoration-cp-member-card" :style="cardStyle">
    <div>
      <strong>{{ title }}</strong>
      <span>{{ subtitle }}</span>
    </div>
    <i :style="badgeStyle">{{ pointsText }}</i>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() => stringValue(props.component.props?.title, '会员中心'))
const subtitle = computed(() => stringValue(props.component.props?.subtitle))
const pointsText = computed(() => stringValue(props.component.props?.pointsText, '登录送 10 积分'))
const cardStyle = computed(() => {
  const color =
    stringValue(props.component.style?.cardColor) ||
    props.themeTokens?.primaryColor ||
    props.themeColor ||
    'var(--ren-theme-primary)'
  return { backgroundColor: color }
})
const badgeStyle = computed(() => {
  const color = props.themeTokens?.primaryColor || props.themeColor || 'var(--ren-theme-primary)'
  return { borderColor: color, color }
})
</script>
